export default function PlatformBusinessApps() {
  return (<>
      <section className="section-space apps-section" id="apps">
        <div className="container">
          <div className="section-heading reveal">
            <div className="eyebrow">{"BUSINESS APPLICATIONS"}</div>
            <h2>{"Ready-made systems for everyday operations."}</h2>
            <p>{"Deploy focused applications without commissioning a new project for every business process."}</p>
          </div>
          <div className="app-showcase">
            <div className="app-tabs" role="tablist">
              <button className="app-tab active" data-app="booking">{"Booking Management"}</button>
              <button className="app-tab" data-app="orders">{"Order Management"}</button>
              <button className="app-tab" data-app="builder">{"Builder Management"}</button>
              <button className="app-tab" data-app="crm">{"CRM"}</button>
            </div>
            <div className="app-preview reveal" id="appPreview">
              <div className="app-preview-text">
                <small id="appKicker">{"BOOKING MANAGEMENT"}</small>
                <h3 id="appTitle">{"Manage availability, bookings and payments in one place."}</h3>
                <p id="appDescription">{"Centralize inventory, customer details, payment status, notifications and booking workflows."}</p>
                <ul id="appFeatures">
                  <li>{"Inventory & availability"}</li>
                  <li>{"Booking creation"}</li>
                  <li>{"Payment tracking"}</li>
                  <li>{"Customer notifications"}</li>
                </ul>
              </div>
              <div className="app-screen">
                <div className="screen-top"><span></span><span></span><span></span></div>
                <div className="screen-body">
                  <div className="screen-side"><i></i><i></i><i></i><i></i><i></i></div>
                  <div className="screen-content">
                    <div className="screen-head"></div>
                    <div className="screen-cards"><i></i><i></i><i></i></div>
                    <div className="screen-table">
                      <b></b><b></b><b></b><b></b><b></b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-space trust-section">
        <div className="container">
          <div className="section-heading centered reveal">
            <div className="eyebrow">{"SECURITY & TRUST"}</div>
            <h2>{"Your operations deserve enterprise-grade controls."}</h2>
            <p>{"Security claims should always reflect your actual implementation and verified certifications."}</p>
          </div>
          <div className="trust-grid">
            <div className="trust-card reveal"><span>{"01"}</span><h3>{"Tenant Isolation"}</h3><p>{"Keep organizations logically separated across data and operations."}</p></div>
            <div className="trust-card reveal delay-1"><span>{"02"}</span><h3>{"Role-Based Access"}</h3><p>{"Control access by user, team and responsibility."}</p></div>
            <div className="trust-card reveal delay-2"><span>{"03"}</span><h3>{"Audit Trails"}</h3><p>{"Record important administrative and operational activity."}</p></div>
            <div className="trust-card reveal"><span>{"04"}</span><h3>{"Encryption"}</h3><p>{"Protect data in transit and at rest where implemented."}</p></div>
            <div className="trust-card reveal delay-1"><span>{"05"}</span><h3>{"Monitoring"}</h3><p>{"Detect failures, anomalies and operational issues quickly."}</p></div>
            <div className="trust-card reveal delay-2"><span>{"06"}</span><h3>{"Backup & Recovery"}</h3><p>{"Support resilience with continuity and recovery processes."}</p></div>
          </div>
        </div>
      </section>

      <section className="section-space compare-section">
        <div className="container compare-wrap">
          <div className="section-heading reveal">
            <div className="eyebrow">{"SIMPLIFY OPERATIONS"}</div>
            <h2>{"Stop managing vendors."}<br />{"Start managing your business."}</h2>
          </div>
          <div className="compare-grid">
            <div className="compare-column muted reveal">
              <small>{"TRADITIONAL SETUP"}</small>
              <div>{"Development company"}</div><div>{"DevOps provider"}</div><div>{"QA vendor"}</div><div>{"Security vendor"}</div><div>{"Payment integrator"}</div><div>{"Support provider"}</div><div>{"CRM vendor"}</div><div>{"Chatbot vendor"}</div><div>{"Multiple invoices"}</div>
            </div>
            <div className="compare-center">{"→"}</div>
            <div className="compare-column strong reveal delay-1">
              <small>{"ONESTACK"}</small>
              <div>{"One platform"}</div><div>{"One account"}</div><div>{"Connected modules"}</div><div>{"Managed experts"}</div><div>{"Unified billing"}</div><div>{"One operational view"}</div><div>{"Flexible scale"}</div><div>{"Country configuration"}</div><div>{"One support relationship"}</div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-space solutions-section" id="solutions">
        <div className="container">
          <div className="section-heading centered reveal">
            <div className="eyebrow">{"SOLUTIONS"}</div>
            <h2>{"Designed around the way different businesses grow."}</h2>
          </div>
          <div className="solution-grid">
            <article className="solution-card reveal"><span>{"STARTUPS"}</span><h3>{"Launch without building every team yourself."}</h3><p>{"Development, DevOps, QA, CRM, payments and support."}</p></article>
            <article className="solution-card reveal delay-1"><span>{"SME"}</span><h3>{"Operate with capabilities normally reserved for larger companies."}</h3><p>{"Flexible software and managed services without heavy fixed cost."}</p></article>
            <article className="solution-card reveal delay-2"><span>{"ENTERPRISE"}</span><h3>{"Add flexible technology around your existing stack."}</h3><p>{"Integrations, managed operations and specialized delivery."}</p></article>
            <article className="solution-card reveal"><span>{"FINTECH"}</span><h3>{"Engineering for complex financial workflows."}</h3><p>{"Payments, reconciliation, APIs, DevOps, QA and security."}</p></article>
            <article className="solution-card reveal delay-1"><span>{"ECOMMERCE"}</span><h3>{"Connect checkout, orders and customer experience."}</h3><p>{"Payments, orders, CRM, WhatsApp and customer support."}</p></article>
            <article className="solution-card reveal delay-2"><span>{"REAL ESTATE"}</span><h3>{"Manage leads, inventory, bookings and collections."}</h3><p>{"CRM, booking, payments, WhatsApp and builder management."}</p></article>
          </div>
        </div>
      </section>

  </>);
}
